export const SEARCH_MODE = {
  DEFAULT_MODE: 'default',
  FILTER_MODE: 'filter',
}
